import React from 'react'

import { withTranslate } from 'react-redux-multilingual'
import { Typography, Card, CardContent, Grid } from '@material-ui/core'
import { ErrorOutline } from '@material-ui/icons'

const NotFound = ({ translate }) => {
  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction={'column'}
          alignItems={'center'}
          justify={'center'}
          style={{ height: window.screen.availHeight * 0.75 }}>
          <Grid item>
            <Typography color={'textSecondary'}>
              <ErrorOutline style={{ fontSize: 72 }} />
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant={'h4'} color={'textSecondary'}>
              {translate('pageNotFound')}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default withTranslate(NotFound)
